<template>
  <div class="parallax-container">
    <ul class="container collapsible">
      <li class="active">


        <div v-if="$route.params.ok=='ok'" class="row collapsible-body">
          <h4 class="header col s12 light">Merci d'avoir réservé vos billets !</h4>
          <br />&nbsp;
          <br />&nbsp;
          <p>
            Vous allez recevoir vos billets par email. Nous vous conseillons toutefois
            de les télécharger ici, et de bien noter votre CODE RÉSERVATION qui vous
            permettra de modifier votre réservation en cas de nécessité.
          </p>
          <p>Liens de téléchargement :</p>
          <button class="btn">&nbsp;</button>
          <button class="btn">&nbsp;</button>
        </div>


        <div v-else class="row collapsible-body">
          <h4 class="header col s12 light">Une erreur s'est produite !</h4>
          <br />&nbsp;
          <br />&nbsp;
          <p>
            Le règlement ne s'est pas déroulé correctement, ou a été annulé.
            Vous pouvez <a href="/#/">revenir à l'accueil</a> pour réitérer votre
            réservation.
          </p>
        </div>


      </li>
    </ul>
    <div class="parallax">
      <img src="../assets/para-2.jpg" alt="Le Gombessa" />
    </div>
  </div>
</template>



<script>
import M from "materialize-css";

export default {
  mounted() {
    // collapsible, mobile menu
    M.AutoInit();
  }
};
</script>



<style scoped>
@media (max-width: 600px) {
  body .parallax-container {
    background-color: white !important;
  }
}

.collapsible-body {
  background-color: white;
  margin-top: 105px;
  margin-bottom: 0;
  color: rgba(0, 0, 0, 0.87);
}
</style>